module.exports = __webpack_public_path__ + "img/weather27.938c131c.png";